import axios from "axios";

const BASE_URL = "https://api.mshelhomes.com/api/mshel-club";

export default {
  /**
   * Fetch training types for MMC
   * @returns {Promise} Axios promise containing the response
   */
  getTrainingTypeMmc() {
    return axios.get(`${BASE_URL}/get-training-types/mmc`);
  },

  /**
   * Fetch training types for REM
   * @returns {Promise} Axios promise containing the response
   */
  getTrainingTypeMrem() {
    return axios.get(`${BASE_URL}/get-training-types/rem`);
  },

  /**
   * Fetch the list of business sectors
   * @returns {Promise} Axios promise containing the response
   */
  getBusinessSector() {
    return axios.get(`${BASE_URL}/business-sectors`);
  },

  /**
   * Create a new registration
   * @param {Object} body - The payload for the registration
   * @returns {Promise} Axios promise containing the response
   */
  createRegistration(body) {
    return axios.post(`${BASE_URL}/new-registration`, body);
  },
};
